import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { maintenanceRequestLogsService } from '@/services/maintenance';

export const useMaintenanceRequestLogs = () => {
  return useQuery({
    queryKey: queryKeys.maintenanceRequests.logs(),
    queryFn: () => maintenanceRequestLogsService.listLogs(),
    staleTime: 30_000,
  });
};
